import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store'; 
import AppRoutes from './routes/routes';
import { Toaster } from 'react-hot-toast'; 

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" reverseOrder={false} /> 
      </BrowserRouter>
    </Provider>
  );
}

export default App;
